import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Alert,
  Button,
  Stack,
  Container,
  Grid,
} from "@mui/material";

import Logo from "../assets/img/logo.svg";

import { NavigationComponent } from "./navigation";

import QRScanner from "qr-scanner";

import { useAppSelector, useAppDispatch } from "../redux/hooks";
import { backdrop, getApp, message } from "../redux/app.slice";
// Campus IP based attendance check disabled
// import { verifyStudentCampusIp } from "../modules/campus-ip";

const getCameraErrorMessage = (error: unknown) => {
  if (!window.isSecureContext) {
    return "Camera access is blocked because this page is using HTTP. Open the app over HTTPS, or use localhost when testing on this device.";
  }

  const errorName = error instanceof DOMException ? error.name : "";

  switch (errorName) {
    case "NotAllowedError":
    case "SecurityError":
      return "Camera permission was denied. Allow camera access in your browser settings, then try again.";
    case "NotFoundError":
    case "DevicesNotFoundError":
      return "No camera was found on this device.";
    case "NotReadableError":
    case "TrackStartError":
      return "The camera is already in use by another app or could not be started.";
    default:
      return "The camera could not be started. Check the browser camera permission and try again.";
  }
};

// Campus IP based attendance check disabled
// const ENFORCE_CAMPUS_IP = false;

export const AttendanceComponent = () => {
  const navigate = useNavigate();
  const app = useAppSelector(getApp);
  const dispatch = useAppDispatch();
  const [cameraError, setCameraError] = useState<string | null>(null);
  const [cameraRetry, setCameraRetry] = useState(0);

  useEffect(() => {
    if (!app.isLoggedIn) navigate("/");
  }, [app.isLoggedIn, navigate]);

  useEffect(() => {
    let active = true;
    const video_element = document.getElementById(
      "video_scanner"
    ) as HTMLVideoElement;
    if (video_element) {
      const handleScan = async (scanData: string, scanner: QRScanner) => {
        if (!app.student) return;

        scanner.stop();
        dispatch(backdrop(true));

        try {
          // Campus IP based attendance check disabled
          // if (ENFORCE_CAMPUS_IP) {
          //   const campusIp = await verifyStudentCampusIp(
          //     app.student,
          //     app.campuses
          //   );
          //
          //   if (!campusIp.campusKey) {
          //     dispatch(
          //       message({
          //         open: true,
          //         severity: "error",
          //         message:
          //           "Unable to verify your campus for attendance. Please login again.",
          //       })
          //     );
          //     scanner.start();
          //     return;
          //   }
          //
          //   if (campusIp.allowedIps.length === 0) {
          //     dispatch(
          //       message({
          //         open: true,
          //         severity: "error",
          //         message:
          //           "Attendance IP restriction is not configured for your campus.",
          //       })
          //     );
          //     scanner.start();
          //     return;
          //   }
          //
          //   if (!campusIp.allowed) {
          //     dispatch(
          //       message({
          //         open: true,
          //         severity: "error",
          //         message:
          //           "You must be connected to your campus network to mark attendance.",
          //       })
          //     );
          //     scanner.start();
          //     return;
          //   }
          // }

          const data = encodeURIComponent(scanData);
          console.log("Attendance data:", data);
          console.log("Student ID:", app.student.id);
          console.log("Student secret:", app.student.secret);
          window.location.href = `${process.env.REACT_APP_APP_URL}attendance/${data}/${app.student.id}/${app.student.secret}`;
        } catch (error) {
          dispatch(
            message({
              open: true,
              severity: "error",
              message:
                "Unable to verify your IP address. Please try again from the campus network.",
            })
          );
          scanner.start();
        } finally {
          dispatch(backdrop(false));
        }
      };

      const scanner = new QRScanner(
        video_element,
        (result) => {
          if (result && app.student) {
            handleScan(result.data, scanner);
          }
        },
        {
          highlightScanRegion: true,
          returnDetailedScanResult: true,
        }
      );
      setCameraError(null);
      scanner.start().catch((error) => {
        if (active) setCameraError(getCameraErrorMessage(error));
      });

      return () => {
        active = false;
        scanner.stop();
        scanner.destroy();
      };
    }
  }, [app.campuses, app.student, cameraRetry, dispatch]);

  return (
    <>
      <NavigationComponent />
      <Container maxWidth="sm" style={{ margin: "2em auto" }}>
        <Stack spacing={2}>
          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justifyContent="center"
            style={{ marginBottom: "1em" }}
          >
            <img
              src={Logo}
              width={100}
              alt="London School of Commerce Group of Colleges Logo"
            />
          </Grid>
          {cameraError && (
            <Alert
              severity="error"
              action={
                window.isSecureContext ? (
                  <Button
                    color="inherit"
                    size="small"
                    onClick={() => setCameraRetry((retry) => retry + 1)}
                  >
                    Try again
                  </Button>
                ) : undefined
              }
            >
              {cameraError}
            </Alert>
          )}
          <video
            id="video_scanner"
            height="100%"
            width="100%"
            autoPlay
            muted
            playsInline
          ></video>
        </Stack>
      </Container>
    </>
  );
};
